import React from 'react';
import Styles from './lessons-grid-styles.scss';
import LessonGridLoader from './lesson-grid-loader/lesson-grid-loader';
import LessonGridItem from './lesson-grid-item/lesson-grid-item';
import { useNavigate } from 'react-router';
import LessonGridItemCurrent from './lesson-grid-item-current/lesson-grid-item-current';
const LessonsGrid = ({ loading = false, module, lessons, isTrial = false, allLocked = false }) => {
    const navigate = useNavigate();
    const spliceArrayIfIsTrial = (lessons) => {
        if (isTrial) {
            return lessons.splice(0, 1);
        }
        else {
            return lessons;
        }
    };
    return (React.createElement("div", { className: Styles.lessonsGridWrap },
        React.createElement("div", { className: Styles.lessonsGrid }, loading ? (React.createElement("div", { style: { width: '100%' } },
            React.createElement(LessonGridLoader, null))) : (React.createElement(React.Fragment, null, spliceArrayIfIsTrial(lessons).map((lesson, index) => {
            if (lesson.studentPercentageProgressInLesson === 100) {
                return (React.createElement(LessonGridItem, { key: `Lesson-${lesson.id}`, locked: false, score: lesson.studentScoreInLesson, id: index + 1, lesson: lesson, onClick: () => {
                        navigate(`/student-dashboard/my-modules/${module.id}/lessons/${lesson.id}/overview`);
                    } }));
            }
            else if (lesson.currentLesson && !allLocked) {
                return (React.createElement(LessonGridItemCurrent, { key: `Lesson-${lesson.id}`, lesson: lesson, id: index + 1, onClick: () => {
                        navigate(`/student-dashboard/my-modules/${module.id}/lessons/${lesson.id}/overview`);
                    }, locked: allLocked }));
            }
            else {
                return (React.createElement(LessonGridItem, { key: `Lesson-${lesson.id}`, locked: true, id: index + 1, lesson: lesson, onClick: () => {
                        navigate(`/student-dashboard/my-modules/${module.id}/lessons/${lesson.id}/overview`);
                    } }));
            }
        }))))));
};
/*
           

          
  */
export default LessonsGrid;
